import React from 'react';

const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const highlightLandingText = (text: string, words: string[]): React.ReactNode => {
  if (!text || words.length === 0) return text;
  const sorted = [...words].sort((a, b) => b.length - a.length);
  const regex = new RegExp(`(${sorted.map(escapeRegex).join('|')})`, 'gi');
  const normalized = new Set(words.map(w => w.toLowerCase()));
  return text.split(regex).map((part, index) => {
    if (normalized.has(part.toLowerCase())) {
      return (
        <span key={index} className="accent-text">
          {part}
        </span>
      );
    }
    return <span key={index}>{part}</span>;
  });
};
